namespace Gamification.Gamification {
    export interface DispositiviForm {
        UserId: Serenity.IntegerEditor;
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.TextAreaEditor;
        Note: Serenity.TextAreaEditor;
    }

    export class DispositiviForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Dispositivi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DispositiviForm.init)  {
                DispositiviForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.TextAreaEditor;

                Q.initFormType(DispositiviForm, [
                    'UserId', w0,
                    'Nome', w1,
                    'Descrizione', w2,
                    'Note', w2
                ]);
            }
        }
    }
}
